// src/context/ColorModeContext.js
import { createContext } from "react";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });
